<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
	import BlueButton from "../BlueButton.svelte";

	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import SectionBoard from "../../molecules/SectionBoard.svelte";

	let loading = false
	let models = []

	const name = 'mail/templates'

	const handleSubject = (model) => (event) => {
		model.subject = event.detail.value
	}

	const handleBody = (model) => (event) => {
		model.body = event.detail.value
	}

	onMount(async () => {
		const client = ApiService.createClient()
		const { data } = await client.get('/settings/defaultTitle')
		if (!data.defaultTitle) {
			return
		}

		const response = await client.get(`/${name}`)
		if (!response.data.mailTemplates) {
			return
		}
		console.log(response)
		models = response.data.mailTemplates
	})

	const save = (model) => async () => {
		console.log(model)
		const client = ApiService.createClient()
		loading = true
		const { data } = await client.post(`/${name}`, model)
		loading = false
	}
</script>

{#each models as m(m.id)}
	<SectionBoard klass="mt-8 first:mt-0">
		<h2 class="font-semibold">
			{m.name}
		</h2>

		<div class="mt-6">
			<FormWithLabel
				label="タイトル"
				input={handleSubject(m)}
				value={m.subject}
			/>
		</div>

		<div class="mt-6">
			<FormWithLabel
				label="本文"
				input={handleBody(m)}
				value={m.body}
				inputType="textarea"
			/>
		</div>

		<BlueButton rounded klass="mt-4" click={save(m)} loading={loading}>
			更新する
		</BlueButton>
	</SectionBoard>
{/each}